import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Paged } from '../models/shared/paged';
import { GetCandidateResumeJobsHomePage, GetJobsHomePage, GetJobsHomePageSummary, JobsHomePageFilterParameters } from '../models/homePage/jobs-home-page';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtil } from '../utils/http-util';

@Injectable({
  providedIn: 'root'
})
export class JobsHomePageService {

  constructor(
    private _http: HttpClient
  ) { }

  public getJobsHomePage(params: JobsHomePageFilterParameters): Observable<Paged<GetJobsHomePage>> {
    return this._http.get<Paged<GetJobsHomePage>>(`${environment.api.url}/JobsHomePage`, {
      params: HttpUtil.toHttpParams(params)
    });
  }

  public getCandidateResumeJobsHomePage(resumeId?: number): Observable<GetCandidateResumeJobsHomePage> {
    return this._http.get<GetCandidateResumeJobsHomePage>(`${environment.api.url}/JobsHomePage/candidate-resume`, {
      params: HttpUtil.toHttpParams({ resumeId })
    });
  }


  public addJobApplicationsNotInterested(jobOfferId: number): Observable<any> {
    return this._http.post<any>(`${environment.api.url}/JobsHomePage/not-interested`, {
      jobOfferId: jobOfferId,
      isEnabled: true
    });
  }

  public addJobApplicationsFavorite(jobOfferId: number): Observable<any> {
    return this._http.post<any>(`${environment.api.url}/JobsHomePage/favorite`, {
      jobOfferId: jobOfferId,
      isEnabled: true
    });
  }

  public getJobsHomePageSummary(resumeId: number): Observable<GetJobsHomePageSummary> {
    return this._http.get<GetJobsHomePageSummary>(`${environment.api.url}/JobsHomePage/summary/${resumeId}`);
  }

}